import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const MailIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M16.6667 3C15.425 3 14.3792 3.85 14.0833 5H10.2167C12.1042 6.32917 13.3333 8.52083 13.3333 11V18.3333C13.3333 19.3583 12.95 20.2917 12.3167 21H21.3333C22.8042 21 24 19.8042 24 18.3333V11C24 9.225 23.2292 7.625 22 6.52917V5.66667C22 4.19583 20.8042 3 19.3333 3H16.6667ZM16.6667 11.6667C16.3 11.6667 16 11.3667 16 11V7V5.66667C16 5.3 16.3 5 16.6667 5H19.3333C19.7 5 20 5.3 20 5.66667V7C20 7.36667 19.7 7.66667 19.3333 7.66667H17.3333V11C17.3333 11.3667 17.0333 11.6667 16.6667 11.6667ZM0 11V18.3333C0 19.8042 1.19583 21 2.66667 21H9.33333C10.8042 21 12 19.8042 12 18.3333V11C12 7.6875 9.3125 5 6 5C2.6875 5 0 7.6875 0 11ZM2.66667 11C2.66667 10.6333 2.96667 10.3333 3.33333 10.3333H8.66667C9.03333 10.3333 9.33333 10.6333 9.33333 11C9.33333 11.3667 9.03333 11.6667 8.66667 11.6667H3.33333C2.96667 11.6667 2.66667 11.3667 2.66667 11Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default MailIcon
